'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = featureEditor;

var _frame = require('../frame');

function featureEditor(state, action) {
    return (0, _frame.FrameReducer)(state, action);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9saWIvbWFwaW8vRmVhdHVyZUVkaXRvclJlZHVjZXIuanN4Il0sIm5hbWVzIjpbImZlYXR1cmVFZGl0b3IiLCJzdGF0ZSIsImFjdGlvbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7a0JBRXdCQSxhOztBQUZ4Qjs7QUFFZSxTQUFTQSxhQUFULENBQXVCQyxLQUF2QixFQUE4QkMsTUFBOUIsRUFBc0M7QUFDakQsV0FBTyx5QkFBYUQsS0FBYixFQUFvQkMsTUFBcEIsQ0FBUDtBQUNIIiwiZmlsZSI6IkZlYXR1cmVFZGl0b3JSZWR1Y2VyLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHtGcmFtZVJlZHVjZXJ9IGZyb20gJy4uL2ZyYW1lJ1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBmZWF0dXJlRWRpdG9yKHN0YXRlLCBhY3Rpb24pIHtcbiAgICByZXR1cm4gRnJhbWVSZWR1Y2VyKHN0YXRlLCBhY3Rpb24pO1xufVxuIl19